import { useState } from 'react';
import { Info, ChevronDown, ChevronUp, Database, Calculator, HelpCircle } from 'lucide-react';

/**
 * Ajuda contextual leve para modulos.
 * Mostra: o que faz, origem dos dados, como calcula, legendas.
 */
export function ModuleInfo({ descricao, dados, calculo, legendas }) {
  const [open, setOpen] = useState(false);

  const sections = [
    { icon: Info, label: 'O que faz', content: descricao },
    { icon: Database, label: 'Origem dos dados', content: dados },
    { icon: Calculator, label: 'Como calcula', content: calculo },
    { icon: HelpCircle, label: 'Legendas', content: legendas },
  ].filter(s => s.content);

  if (sections.length === 0) return null;

  return (
    <div data-testid="module-info">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
        data-testid="module-info-toggle"
      >
        <Info className="h-3.5 w-3.5" />
        <span>Ajuda</span>
        {open ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
      </button>
      {open && (
        <div className="mt-2 p-3 rounded-md border border-border/50 bg-muted/20 text-xs space-y-2 animate-in fade-in duration-200" data-testid="module-info-content">
          {sections.map((s, i) => (
            <div key={i} className="flex gap-2">
              <s.icon className="h-3.5 w-3.5 mt-0.5 flex-shrink-0 text-muted-foreground" />
              <div>
                <span className="font-medium text-foreground">{s.label}: </span>
                <span className="text-muted-foreground">{s.content}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
